import { NoveltyCampaign } from '@/models/novelty/novelty'
import { CampaignSummary } from '@/usecases/novelty/campaign-summary'
import { CheckoutStore } from '@spa/components/pages/order/order/models/checkout-store'
import { CartItem } from '@spa/store/modules/cart/types'
import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import { Prop } from 'vue-property-decorator'

@Mixin
export class WithCheckoutComponentProps extends Vue {
  @Prop({ required: true })
  readonly checkoutStore: CheckoutStore

  @Prop({ default: false })
  readonly isFreeShipping: boolean

  @Prop({ required: true })
  readonly serviceFeePercent: number

  @Prop({ required: true })
  noveltyCampaign: NoveltyCampaign | null

  @Prop({ required: true })
  noveltyCartItems: CartItem[]

  @Prop({ required: true })
  canScheduleDelivery: boolean

  @Prop({ required: true })
  noveltySummary: CampaignSummary

  @Prop({ required: true })
  orderButtonIsEnabled: boolean

  @Prop({ required: true })
  readonly pointIsEnabled: boolean

  @Prop({ required: true })
  readonly estimateIsLoading: boolean
}
